document.addEventListener( 'DOMContentLoaded', function () {
	window.dataLayer = window.dataLayer || [];

	// get data for the Up Next Pop Up
	let nextEpisode = null, nextEpisodeUrl = null, nextEpisodeTitle = null, nextEpisodeRuntime = null;

	const episodeList = document.querySelector( '.episode-list' ); 
	if ( episodeList ) {
		nextEpisode = episodeList.querySelector( '.episode-number.selected' ).nextElementSibling;
	}


	if ( nextEpisode ) {
		nextEpisodeUrl = nextEpisode.href;
		const nextEpisodeAttributes = nextEpisode.getAttribute( 'title' );
		const titleAndRuntime = nextEpisodeAttributes.match( /^(.*?)\s*(?:\((\d+(?::\d+)?)\))?$/ );
		nextEpisodeTitle = titleAndRuntime[1];
		const videoLength = nextEpisode.querySelector( '.video-length' );
		if ( videoLength ) nextEpisodeRuntime = videoLength.textContent.replace( /\(|\)/g, '' );
	}
	

	const upNextContainer = document.querySelector( '.up-next' );
	const upNextTitle = document.querySelector( '.up-next-title' );
	const upNextRuntime = document.querySelector( '.up-next-runtime' );

	if ( videojs && videojs.getPlayer( 'hmBrightcove' ) ) {
		videojs.getPlayer( 'hmBrightcove' ).on( 'playing', function () {
			let myPlayer = this;
			let isAudio = document.querySelector( '.wp-block-hm-brightcove-with-tracking.video__id.is-audio' );
			let playerEvent = isAudio ? 'audio_start' : 'video_start';
			let playEventLogged = false;

			const videoTitle = myPlayer.mediainfo.name;
			const playerId = myPlayer.bcinfo.playerId;
			const videoId = myPlayer.mediainfo.id;

			if ( !playEventLogged ) {
				window.dataLayer.push({
					'event': playerEvent,
					'videoTitle': videoTitle,
					'playerId': playerId,
					'videoId': videoId
				} );
				playEventLogged = true;
			}
		} );
	}

	if ( videojs && videojs.getPlayer( 'hmBrightcove' ) ) {
		videojs.getPlayer( 'hmBrightcove' ).ready( function () {
			let myPlayer = this;

			if ( nextEpisodeUrl ) {
				const videoElement = document.getElementById( 'hmBrightcove' );
				const autoadvanceEnabled = videoElement.getAttribute( 'data-autoadvance' ) === '1';

				upNextContainer.href = nextEpisodeUrl;
				upNextTitle.textContent = nextEpisodeTitle;
				upNextRuntime.textContent = nextEpisodeRuntime;

				const closeButton = document.querySelector( '.x-icon' );
				if ( closeButton ) {
					closeButton.addEventListener( 'click', function( e ) {
						e.preventDefault();
						upNextContainer.style.display = 'none';
					} );
				}
				
				// display Up Next tile in player
				myPlayer.on( 'timeupdate', function() {
					const remainingTime = myPlayer.duration() - myPlayer.currentTime();
					if ( remainingTime <= 6 ) {
						upNextContainer.style.display = 'block';
					}
				} );

				// listen for end of video and advance page to the next episode
				if ( autoadvanceEnabled ) {
					myPlayer.on( 'ended', function() { 
						window.location.href = nextEpisodeUrl;
					} );
				}
			}
		} );
	}
} );